import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import _get from "lodash/get";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n        font-size: 1.125rem;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n        padding-right: 0;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { media } from '~layout';
import { typographyTheme } from '~typography';
import formTheme from '../../styles/formTheme';
var FormSwitchLabel = styled.label.withConfig({
  displayName: "FormSwitchLabel",
  componentId: "sc-13v83c9-0"
})(["color:", ";display:inline-block;font-family:", ";font-size:0.9375rem;margin:0;padding-right:1rem;", " ", ""], function (props) {
  return _get(props, "theme.form.switch.label[" + props.skin + "].color", formTheme.form.switch.label[props.skin].color);
}, function (_ref) {
  var theme = _ref.theme;
  return _get(theme, 'typography.base.fontFamily', typographyTheme.typography.base.fontFamily);
}, media.xs(_templateObject()), media.lg(_templateObject2()));
export default FormSwitchLabel;